import {
  Button,
  connectYourBank,
  Disclaimer,
  Div,
  H3,
  Img,
  LockIcon,
  ModalPortal,
  P,
  isPartner,
  Wallets,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const ConnectYourBank = ({
  isOpen,
  setIsOpen,
  setModalIsOpen,
}: {
  isOpen: Wallets | boolean | null;
  setIsOpen: Dispatch<SetStateAction<Wallets | boolean | null>>;
  setModalIsOpen: Dispatch<SetStateAction<Wallets | boolean | null>>;
}) => {
  return (
    <ModalPortal
      isOpen={!!isOpen}
      closeModal={() => setIsOpen(null)}
      width="400px"
    >
      <Div $flex $center $mb="24">
        <Img alt="" src={connectYourBank} $width="250px" $widthSM="200px" />
      </Div>

      <H3 $mb="8" $center>
        Connect {isPartner ? 'Your' : 'This account'} Bank
      </H3>

      <P $center $mb="50">
        Link {isPartner ? 'your' : 'this account'} account securely to start
        receiving payouts.
      </P>

      <Disclaimer $center $mb="16">
        <LockIcon /> {isPartner ? 'Your information' : 'Information'} is
        encrypted and securely stored.
      </Disclaimer>

      <Button
        $w="100%"
        $selected
        onClick={() => {
          setModalIsOpen(isOpen);
          setIsOpen(null);
        }}
      >
        Get Started
      </Button>
      <Button $mt="8" $gray $w="100%" $selected onClick={() => setIsOpen(null)}>
        Cancel
      </Button>
    </ModalPortal>
  );
};
